<template>
    <main>
        <section class="section register-form">
            <div class="card py-4">
                <div class="card-content">
                    <div v-if="agendaReunion()">
                        <div class="columns">
                            <div class="column is-12 is-12-desktop">
                                <div class="has-text-centered mb-5">
                                    <div
                                        class="is-flex is-justify-content-left"
                                    >
                                        <p class="is-size-6 has-text-left mb-4">
                                            Paso 1:
                                        </p>
                                    </div>
                                    <div
                                        class="is-flex is-justify-content-center"
                                    >
                                        <p
                                            class="is-size-6 has-text-centered mb-4"
                                        >
                                            <span
                                                class="has-text-weight-semibold"
                                            >
                                                Agenda tu reunión
                                            </span>
                                            de Kick-Off con nuestro equipo
                                            experto.
                                        </p>
                                    </div>
                                    <b-button
                                        type="is-secondary"
                                        @click="changeValue"
                                        :disabled="
                                            urlHelp === '' || wentToUrlHelp
                                        "
                                        :icon-right="
                                            wentToUrlHelp ? 'check' : ''
                                        "
                                    >
                                        <div
                                            class="is-flex is-justify-content-space-between is-align-item-center"
                                        >
                                            <span>Mostrar calendly</span>
                                        </div>
                                    </b-button>
                                    <div
                                        v-show="wentToUrlHelp"
                                        class="calendly-inline-widget"
                                        data-url="https://calendly.com/cforemoto/kick-off-plan-pro-cfo?primary_color=11b9be"
                                        style="min-width:320px;height:1200px;"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="columns">
                            <div class="column is-12 is-12-desktop">
                                <div class="is-flex is-justify-content-left">
                                    <p class="is-size-6 has-text-left mb-4">
                                        <span v-if="user.client_type == ESSENTIAL"
                                            >Paso 2:</span
                                        >
                                    </p>
                                </div>
                                <Diagram />
                                <br/>
                                <SIIconnectFast
                                    :mensajeCorto="true"
                                    @onConnectSii="onConnectSii"
                                    :widget-is-loading="widgetIsLoading"
                                    :hasConnectSII="
                                        hasSIIAutomation
                                            ? hasSIIAutomation
                                            : hasConnectSII
                                    "
                                />
                            </div>
                        </div>
                    </div>
                    <div v-if="user.client_type == ESSENTIAL">
                        <div class="horizontal-separator my-5"></div>
                        <div class="columns">
                            <div class="column is-12 is-12-desktop">
                                <div class="is-flex is-justify-content-left">
                                    <p class="is-size-6 has-text-left mb-4">
                                        Paso 3:
                                    </p>
                                </div>
                                <BookRemunerations
                                    @onUploadBook="onUploadBook"
                                    :hasUplodedFile="hasUplodedFile"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="horizontal-separator my-5"></div>
                        <div class="columns">
                            <div class="column is-12 is-12-desktop">
                                <div class="has-text-centered mb-5">
                                    <div
                                        class="is-flex is-justify-content-center"
                                    >
                                        <p
                                            class="is-size-6 has-text-centered mb-4"
                                        >
                                            <span
                                                class="has-text-weight-semibold"
                                            >
                                                Finaliza el proceso
                                            </span>
                                        </p>
                                    </div>
                                    <b-button
                                        type="is-secondary"
                                        @click="allReady"
                                        :disabled="!wentToUrlHelp"
                                    >
                                        <div
                                            class="is-flex is-justify-content-space-between is-align-item-center"
                                        >
                                            <span>Completar</span>
                                        </div>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="is-hidden-tablet my-4">
            <div class="notification is-info is-light py-5">
                <h3 class="is-size-5 mb-2">Importante</h3>
                <p>
                    Te recomendamos utilizar la versión de escritorio para
                    agregar nuevos documentos.
                </p>
            </div>
        </section>
    </main>
</template>

<script>
import { getFintocToken, saveFintocUserHolder } from "@/api/fintoc";
import { refresh } from "@/api/security";
import BookRemunerations from "@/components/fillData/components/BookRemunerations";
import SIIconnectFast from "@/components/fillData/components/SIIconnectFast";
import Diagram from "@/components/fillData/components/Diagram";
import config from "@/config";
import router from "@/router";
import { getSession } from "@/utils/auth";
import { BASIC, ESSENTIAL, ENTERPRISE } from "@/utils/clientTypes";
import { mapActions, mapState } from "vuex";

export default {
    name: "FillData",
    components: {
        SIIconnectFast,
        BookRemunerations,
        Diagram,
    },
    data() {
        return {
            widget: () => {},
            showSuccesfullMsg: null,
            widgetIsLoading: false,
            hasUplodedFile: false,
            hasConnectSII: false,
            wentToUrlHelp: false,
            urlHelp: "https://calendly.com/cforemoto/kick-off-plan-pro-cfo",
            ESSENTIAL,
            BASIC,
        };
    },
    computed: {
        ...mapState("userAuth", ["user", "hasSIIAutomation"]),
    },
    methods: {
        ...mapActions("userAuth", [
            "clearUserInfo",
            "setLoginInfo",
            "deleteSelf",
        ]),
        agendaReunion() {
            return [ESSENTIAL, ENTERPRISE].includes(this.user.client_type);
        },
        changeValue() {
            this.wentToUrlHelp = true;
        },
        onConnectSii() {
            const product_type = "invoices";
            this.widgetIsLoading = true;
            getFintocToken({ product_type: product_type })
                .then((response) => {
                    this.widget = window.Fintoc.create({
                        holderType: "business",
                        product: product_type,
                        publicKey: response.data.public_key,
                        webhookUrl: `${config.webhookAPI}/fintoc_app/link_token/?token=${response.data.webhook_token}`,
                        onExit: () => this.onWidgetExit(),
                        onSuccess: (link) =>
                            this.onWidgetSuccess(
                                response.data["company_product_link"]["id"],
                                link
                            ),
                    });
                    this.widget.open();
                    this.widgetIsLoading = false;
                })
                .catch(() => {});
        },
        async onWidgetSuccess(id, linkp) {
            linkp["company_product_link_id"] = id;
            await saveFintocUserHolder(linkp);
            const session = getSession();
            await refresh(session.token);
            this.hasConnectSII = true;
        },
        onWidgetExit() {
            this.widget.destroy();
        },
        onUploadBook(state) {
            this.hasUplodedFile = state;
        },
        allReady() {
            if (
                // this.hasUplodedFile &&
                // (this.hasConnectSII || this.hasSIIAutomation) &&
                this.wentToUrlHelp ||
                this.hasConnectSII
            ) {
                this.$router.push({
                    name: "Confirm",
                    params: { isUserFast: true },
                });
            }
        },
    },
    created() {
        let session = getSession();
        if (session) {
            this.setLoginInfo(session);
        } else {
            this.clearUserInfo();
            router.push("/");
        }
    },
    mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute(
            "src",
            "https://assets.calendly.com/assets/external/widget.js"
        );
        document.head.appendChild(recaptchaScript);
    },
};
</script>
